<template>
    <div class="relative flex items-center mb-2">
        <input type="text"
               class="w-full"
               :value="value"
               @input="$emit('input', $event.target.value)"
        >
        <div class="absolute right-0 py-1 bg-blue-800 text-white font-bold rounded uppercase mr-4 opacity-50"
             v-text="lang"
             :class="lang === 'it' ? 'px-3' : 'px-2'"
        >

        </div>
    </div>
</template>

<script>
    export default {
        props: ['value', 'lang'],
    }
</script>

<style scoped>

</style>